<template lang="pug">
app-main-content-layout(title='')
  .c-invites-page
    //- Header Section
    section.c-invites-page__header
      .c-invites-page__header-content
        h1.c-invites-page__heading Invitations
        p.c-invites-page__subtitle Manage pending invitations for users and organizations
      .c-invites-page__header-actions
        el-button.c-invites-page__action-btn(
          type="primary"
          @click="dialog = true; serverError = false"
        )
          fai(type="fal" icon="plus-circle").me-2
          span Invite Organization
        el-button.c-invites-page__action-btn(
          type="primary"
          @click="dialoguser = true; serverError = false"
        )
          fai(type="fal" icon="plus-circle").me-2
          span Invite User

    //- Main Content Card
    section.c-invites-content-card
      //- Filters
      article.c-invites-content-card__filters
        InviteFilters(
          v-model="filter"
          :sort-value="sortBy"
          :sort-options="sortOptions"
          @search="handleSearch"
          @update:sortValue="sortBy = $event"
          @sort="sortTable"
        )

    //- Table Section
    section.c-invites-table-section
      //- Skeleton Loader
      template(v-if="loading")
        .c-skeleton-loader
          .c-skeleton-row(v-for="n in 10" :key="n")
            .c-skeleton-cell.c-skeleton-cell--name
            .c-skeleton-cell.c-skeleton-cell--email
            .c-skeleton-cell.c-skeleton-cell--type
      
      //- Table
      el-table(
        v-else
        :data="pagedTableData"
        @row-click="toInviteDetail($event)"
        style="width: 100%"
      ).clickable-rows
        el-table-column(width="15")
        el-table-column(label="Name" min-width="200")
          template(#default="scope")
            .lh-sm
              .font-black {{ scope.row.name }}
        
        el-table-column(label="Email" min-width="200")
          template(#default="scope")
            .lh-sm
              .font-medium {{ scope.row.email }}

        el-table-column(label="Type" min-width="120")
          template(#default="scope")
            span.status-badge.status-badge--user(v-if="scope.row.entity === 'User'") User
            span.status-badge.status-badge--organization(v-else) Organization
      
      //- Pagination
      .c-invites-pagination(v-if="filtered.length > 0")
        .c-invites-pagination__controls
          el-button.c-invites-pagination__button(
            @click="setPage(page - 1)"
            :disabled="page === 1 || loading"
          ) Prev
          .c-invites-pagination__info
            span.c-invites-pagination__page-number Page {{ page }}
            span.c-invites-pagination__item-count(v-if="pagedTableData.length > 0") Showing {{ startItem }}-{{ endItem }} of {{ filtered.length }}
          el-button.c-invites-pagination__button(
            @click="setPage(page + 1)"
            :disabled="!hasMorePages || loading"
          ) Next

  dialog-add-invite(
    v-if="dialog"
    v-model="dialog"
    :sending-invite="sendingInvite"
    @save-item="organizationInvite"
    :server-error="serverError"
    @close-dialog="dialog=false"
  )

  dialog-add-user-invite(
    v-if="dialoguser"
    v-model="dialoguser"
    :sending-invite="sendingInvite"
    @save-item="userInvite"
    :server-error="serverError"
    @close-dialog="dialoguser=false"
  )
</template>

<script>
import {
  defineComponent, ref,
  onMounted, reactive,
  computed,
} from 'vue';
import shared from './shared';
import DialogAddInvite from './DialogAddInvite.vue';
import DialogAddUserInvite from './DialogAddUserInvite.vue';
import InviteFilters from './InviteFilters.vue';

export default defineComponent({
  name: 'Invites',
  components: { DialogAddInvite, DialogAddUserInvite, InviteFilters },
  setup() {
    // let nextToken;
    const {
      route,
      router,
      loading,
      doGetInvites,
      doCreateInvite,
      doCreateUserInvite,
    } = shared();
    const filter = ref('');
    const items = reactive({ items: [] });
    const serverError = ref('');
    const sendingInvite = ref(false);
    const dialog = ref(false);
    const dialoguser = ref(false);
    const sortOptions = [{ label: 'Name', value: 'name' }, { label: 'Email', value: 'email' }];
    const sortBy = ref('');

    function sortTable() {
      if (sortBy.value.value === 'name') {
        items.items.sort((a, b) => a.name.localeCompare(b.name));
      } else if (sortBy.value.value === 'email') {
        items.items.sort((a, b) => a.email.localeCompare(b.email));
      }
    }

    const filtered = computed(() => {
      if (filter.value === '') {
        return items.items;
      }
      const regex = new RegExp(`${filter.value}`, 'gi');
      return items.items.filter((x) => {
        if (x.name) {
          return x.name.match(regex);
        }
        return false;
      });
    });

    async function findInvites() {
      try {
        loading.value = true;
        items.items = await doGetInvites();
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
        // console.log('finally');
      }
    }

    onMounted(async () => {
      await findInvites();
    });

    function toInviteDetail(itm) {
      if (route.path === '/manage/invites') router.push(`invites/${itm.id}/info`);
    }

    async function organizationInvite(item) {
      try {
        loading.value = true;
        sendingInvite.value = true;
        await doCreateInvite(item);
        dialog.value = false;
        await findInvites();
      } catch (err) {
        serverError.value = err.message;
      } finally {
        loading.value = false;
        sendingInvite.value = false;
      }
    }

    async function userInvite(item) {
      try {
        loading.value = true;
        sendingInvite.value = true;
        await doCreateUserInvite(item);
        dialoguser.value = false;
        await findInvites();
      } catch (err) {
        serverError.value = err.message;
      } finally {
        loading.value = false;
        sendingInvite.value = false;
      }
    }
    //________create function for pagination datatable________
    const page = ref(1);
    const pageSize = 10;

    const pagedTableData = computed(() => {
      const start = (page.value - 1) * pageSize;
      const end = start + pageSize;
      if (filter.value !== '') {
        return filtered.value.slice(start, end);
      }

      return items.items.slice(start, end);
    });

    const startItem = computed(() => {
      const start = (page.value - 1) * pageSize;
      return start + 1;
    });

    const endItem = computed(() => {
      const start = (page.value - 1) * pageSize;
      return Math.min(start + pageSize, filtered.value.length);
    });

    const hasMorePages = computed(() => {
      const totalPages = Math.ceil(filtered.value.length / pageSize);
      return page.value < totalPages;
    });

    const setPage = (newPage) => {
      if (newPage < 1) return;
      const totalPages = Math.ceil(filtered.value.length / pageSize);
      if (newPage > totalPages) return;
      page.value = newPage;
    };

    const handleSearch = () => {
      page.value = 1; // Reset to first page on search
    };
    return {
      // data (static)
      loading,
      filter,
      page,
      pageSize,
      pagedTableData,
      startItem,
      endItem,
      hasMorePages,
      // data (reactive)
      items,
      serverError,
      input: ref(),
      dialog,
      dialoguser,
      sendingInvite,
      filtered,
      sortOptions,
      sortBy,
      // methods
      toInviteDetail,
      organizationInvite,
      setPage,
      userInvite,
      sortTable,
      handleSearch,
    };
  },
});
</script>

<style lang="scss" scoped>
// Color Variables - Match Dashboard.vue and Activity page
$color-teal-accent: #01beb0;
$gray-50: #f9fafb;
$gray-100: #f3f4f6;
$gray-200: #e5e7eb;
$gray-300: #d1d5db;
$gray-400: #9ca3af;
$gray-500: #6b7280;
$gray-600: #4b5563;
$gray-700: #374151;
$gray-900: #111827;
$color-purple-text: #4349dd;

.c-invites-page {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-bottom: 0;
  }

  &__header-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  &__heading {
    font-size: 1.875rem;
    font-weight: 600;
    color: $gray-900;
    margin: 0;
    line-height: 1.2;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: $gray-600;
    margin: 0;
    line-height: 1.5;
  }

  &__header-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  &__action-btn {
    height: 36px;
    font-size: 14px;
    border-radius: 8px;
    background-color: white !important;
    border: 1.5px solid $color-purple-text !important;
    color: $color-purple-text !important;

    &:hover,
    &:focus {
      background-color: rgba($color-purple-text, 0.08) !important;
      border-color: color.adjust($color-purple-text, $lightness: -8%) !important;
      color: color.adjust($color-purple-text, $lightness: -8%) !important;
    }

    :deep(span) {
      font-weight: 500;
    }

    :deep(.me-2) {
      margin-right: 0.5rem;
    }
  }
}

// Main Content Card
.c-invites-content-card {
  background: transparent;
  border-radius: 0;
  border: none;
  box-shadow: none;
  overflow: visible;

  &__filters {
    padding: 0;
    border-bottom: none;
  }
}

// Table Section - Match Activity page exactly
.c-invites-table-section {
  background: white;
  border-radius: 16px;
  border: 1px solid #dfdfdf;
  box-shadow: none;
  overflow: hidden;

  // Enable horizontal scrolling
  :deep(.el-table) {
    min-width: 100%;
    border-radius: 0;
  }

  :deep(.el-table__body-wrapper) {
    overflow-x: auto;
  }

  // Table styling - Match Activity page
  :deep(.el-table) {
    .cell {
      color: $gray-700;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      white-space: nowrap;
      padding: 0.5rem 0.5rem;
    }

    th > .cell {
      text-transform: capitalize;
      color: $gray-700;
      font-weight: 600;
      font-size: 0.75rem;
      letter-spacing: 0.05em;
      padding: 0.5rem 0.5rem;
    }

    th.el-table__cell.is-leaf {
      background-color: $gray-50;
      border-bottom: 1px solid $gray-100;
      padding: 0.5rem 0;
    }

    td.el-table__cell {
      border-bottom: 1px solid $gray-100;
      padding: 0.625rem 0;
    }

    .el-table__row {
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: $gray-50;
      }
    }

    .el-table__empty-block {
      min-height: 400px;
    }
  }
}

// Pagination - Simple prev/next style
.c-invites-pagination {
  display: flex;
  justify-content: center;
  padding: 1.5rem;

  &__controls {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  &__button {
    border-radius: 0.375rem;
    font-weight: 500;
    transition: all 0.15s ease;
    background-color: transparent;
    border: 1px solid $gray-300;
    color: $gray-700;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;

    &:hover:not(:disabled) {
      background-color: transparent;
      border-color: $gray-500;
      color: $gray-900;
    }

    &:disabled {
      border-color: $gray-300;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    min-width: 180px;
  }

  &__page-number {
    font-size: 0.875rem;
    font-weight: 600;
    color: $gray-900;
  }

  &__item-count {
    font-size: 0.75rem;
    color: $gray-600;
  }

  @media (max-width: 640px) {
    &__controls {
      flex-direction: column;
      gap: 1rem;
      width: 100%;
    }

    &__button {
      width: 100%;
    }

    &__info {
      order: -1;
    }
  }
}

// Skeleton Loader - Match Activity page
.c-skeleton-loader {
  width: 100%;
  padding: 1rem 0;
}

.c-skeleton-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  gap: 1rem;
  border-bottom: 1px solid $gray-100;

  &:last-child {
    border-bottom: none;
  }
}

.c-skeleton-cell {
  height: 20px;
  background: linear-gradient(90deg, #F0F0F0 25%, #E0E0E0 50%, #F0F0F0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;

  &--name {
    width: 180px;
    flex-shrink: 0;
  }

  &--email {
    width: 200px;
    flex-shrink: 0;
  }

  &--type {
    width: 100px;
    flex-shrink: 0;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Status badges - Match Activity page badge style exactly
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem 0.625rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  border: 1px solid;

  &--user {
    background-color: #E0E7FF;
    color: #4F46E5;
    border-color: #818CF8;
  }

  &--organization {
    background-color: #D1F4F0;
    color: #0D9488;
    border-color: #14B8A6;
  }
}

// Font utilities
.font-black {
  font-weight: 600;
  color: $gray-900;
}

.font-medium {
  font-weight: 500;
  color: $gray-700;
}

.lh-sm {
  line-height: 1.25;
}

// Responsive Design
@media (max-width: 768px) {
  .c-invites-page {
    padding: 1.5rem;

    &__header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    &__heading {
      font-size: 1.5rem;
    }

    &__subtitle {
      font-size: 0.8125rem;
    }

    &__header-actions {
      width: 100%;
      flex-direction: column;
    }

    &__action-btn {
      width: 100%;
    }
  }
}

@media (max-width: 480px) {
  .c-invites-page {
    padding: 1rem;

    &__heading {
      font-size: 1.25rem;
    }

    &__subtitle {
      font-size: 0.75rem;
    }
  }
}
</style>
